import { render, staticRenderFns } from "./TabReservationsEdit.vue?vue&type=template&id=35662db8&"
import script from "./TabReservationsEdit.vue?vue&type=script&lang=ts&"
export * from "./TabReservationsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports